export type DialDispositionId =
  | "interested"
  | "not_interested"
  | "qualified"
  | "unqualified_lead"
  | "add_to_dnc"
  | "no_answer"
  | "not_available"
  | "wrong_number"
  | "sale_closed_won"
  | "sale_closed_lost"
  | "call_back_requested"
  | "voicemail"

export type DialDispositionOption = {
  label: string
  value: DialDispositionId
}

export type DialDispositionGroup = {
  id: string
  options: DialDispositionOption[]
}

/** Three stacked groups of four: interest, deal outcome, reachability. */
export const DIAL_DISPOSITION_GROUPS: DialDispositionGroup[] = [
  {
    id: "interest",
    options: [
      { label: "Qualified", value: "qualified" },
      { label: "Not Qualified", value: "unqualified_lead" },
      { label: "Not Available", value: "not_available" },
      { label: "No Answer", value: "no_answer" },
    ],
  },
  {
    id: "deal",
    options: [
      { label: "Interested", value: "interested" },
      { label: "Not Interested", value: "not_interested" },
      { label: "Add To DNC", value: "add_to_dnc" },
      { label: "Call Back", value: "call_back_requested" },
    ],
  },
  {
    id: "reachability",
    options: [
      { label: "Closed Won", value: "sale_closed_won" },
      { label: "Closed Lost", value: "sale_closed_lost" },
      { label: "Wrong Number", value: "wrong_number" },
      { label: "Voicemail", value: "voicemail" },
    ],
  },
]

/** Flat list for callers that do not need group structure. */
export const DIAL_DISPOSITION_GRID: DialDispositionOption[] =
  DIAL_DISPOSITION_GROUPS.flatMap((group) => group.options)
